import React from "react";
import FormControl from "@mui/material/FormControl";
import axios from "axios";
import Button from "../CustomButtons/Button";
import { Clear, Search, Tune } from "@mui/icons-material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import PropTypes from "prop-types";
import GridItem from "../Grid/GridItem";
import GridContainer from "../Grid/GridContainer";
import {withStyles} from "@mui/styles";
import simpleSearchStyle from "../../assets/jss/material-dashboard-pro-react/components/simpleSearchStyle";
import Input from "@mui/material/Input";
import { NativeSelect } from "@mui/material";
import CustomAdvancedSearch from "./AdvancedSearch";
import UserService from "../../services/UserService";
import { postSimpleSearch } from "../../services/ConfigServices";
import ReactLoading from "react-loading";
import AdvancedSearchContext from "../../context/AdvancedSearchContext";

class SimpleSearch extends React.Component {
  static contextType = AdvancedSearchContext;

  constructor(props) {
    super(props);
    this.state = {
      terms: "",
      fields: "all",
      ids: [],
      resetSearch: false,
      openModal: false,
      searchInProgress: false,
    };
    this.handleTermValueChange = this.handleTermValueChange.bind(this);
    this.handleFieldsValueChange = this.handleFieldsValueChange.bind(this);
    // this.getIds = this.getIds.bind(this);
    //this.resetSearch = this.resetSearch.bind(this);
    //this.getAdvancedResultTree = this.getAdvancedResultTree.bind(this);
    //this.handleHideAdvancedSearch = this.handleHideAdvancedSearch.bind(this);
    this.handleAdvancedSearch = this.handleAdvancedSearch.bind(this);
  }


  getIds = async () => {
    const { fields, terms, ids } = this.state;
    axios
      .post(
        postSimpleSearch(this.context.chartIdGroup),
        {
          fields: fields,
          terms: terms,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((response) => {
        this.setState({
          searchInProgress: false,
          resetSearch: true,
        });
        if (response.status === 200) {
          this.props.ids.splice(0, this.props.ids.length);
          response.data.forEach((element) => this.props.ids.push(element));
          this.props.handleSearch();
          return ids;
        } else if (response.status === 401) {
          alert("unauthorized");
        }
      })
      .catch((error) => {
        console.error("error", error);
      });
    this.setState({
      searchInProgress: true,
    });
  };

  handleTermValueChange(event) {
    this.setState({
      terms: event.target.value,
      resetSearch: false,
    });
  }

  handleFieldsValueChange(event) {
    this.setState({
      fields: event.target.value,
      resetSearch: false,
    });
  }

  resetSearch = () => {
    this.setState({
      terms: "",
      fields: "",
      resetSearch: false,
    });
    this.props.handleCancelSearch();
  };

  getAdvancedResultTree = () => {
    this.setState({
      openModal: false,
    });
    this.props.handleAdvanceTree();
  };

  handleHideAdvancedSearch = () => {
    this.setState({
      openModal: false,
    });
  };

  handleAdvancedSearch() {
    this.setState({
      openModal: true,
    });
  }

  render() {
    const { classes } = this.props;
    return (
      <>
        <div className={classes.searchBox}>
          <div className={classes.itemGrid1}>
            <Input
              className={classes.inputSearch}
              value={this.state.terms}
              name={"terms"}
              placeholder={"Rechercher..."}
              onChange={this.handleTermValueChange}
              disableUnderline={true}
            />
          </div>
          <div item={"true"} xs={6} md={2} lg={1}>
            {this.state.resetSearch === true ? (
              <>
                {/* <ArrowDropUpIcon> </ArrowDropUpIcon>

                <ArrowDropDownIcon> </ArrowDropDownIcon> */}
                {/* <Button
                  type="button"
                  name="resetSearch"
                  color="danger"
                  size={"sm"}
                  round
                  justIcon
                  className={classes.cancelButton}
                  onClick={this.props.nextItem}
                >
                  <ArrowDropDownIcon> </ArrowDropDownIcon>
                </Button> */}
                <Button
                  type="button"
                  name="resetSearch"
                  color="danger"
                  size={"sm"}
                  round
                  justIcon
                  className={classes.cancelButton}
                  onClick={this.resetSearch}
                >
                  <Clear> </Clear>
                </Button></>
            ) : this.state.searchInProgress === false ? (
              <Button
                type="submit"
                color="success"
                round
                justIcon
                onClick={this.getIds}
                className={classes.searchBtn}
                disabled={!this.state.terms}
              >
                <Search className={classes.search}> </Search>
              </Button>
            ) : <Button
              type="submit"
              color="info"
              round
              justIcon
              className={classes.searchBtn}
            >
              <ReactLoading
                type={"balls"}
                color={"#FFFFFF"}
                height={"100%"}
                width={"30px"}
                style={{ marginLeft: "0%", marginTop: "0px", height: "100%", width: "30px", fill: "#FFFFFF" }}
              />
            </Button>}
          </div>
          <div>
            <Button
              type="button"
              name="advancedSearch"
              size={"sm"}
              round
              justIcon
              className={classes.advanceBtn}
              onClick={this.handleAdvancedSearch}
            >
              <Tune> </Tune>
            </Button>
          </div>
          <CustomAdvancedSearch
            open={this.state.openModal}
            handleHideAdvancedSearch={this.handleHideAdvancedSearch}
            handleCloseSearch={this.handleCloseSearch}
            getAdvancedResultTree={() => this.getAdvancedResultTree()}
          />
        </div>

        <GridContainer>
          <GridItem xs={8} lg={8} className={classes.itemGrid2}>
            <FormControl fullWidth className={classes.selectFormControl}>
              <NativeSelect
                // style={{ width: "160px" }}
                value={this.state.fields}
                className={classes.selectField}
                onChange={this.handleFieldsValueChange}
                inputProps={{ name: "fields", id: "fields" }}
                ref={this.selectField}
                disableUnderline={true}
              >
                <option className={classes.optionField} value={"all"}>
                  Tous les champs
                </option>
                <option className={classes.optionField} value={"name"}>
                  Nom
                </option>
                <option className={classes.optionField} value={"address"}>
                  Adresse
                </option>
                <option className={classes.optionField} value={"pdl"}>
                  Pdl
                </option>
              </NativeSelect>
            </FormControl>
          </GridItem>
        </GridContainer>
      </>
    );
  }
}

export default withStyles(simpleSearchStyle)(SimpleSearch);

SimpleSearch.propTypes = {
  handleSearch: PropTypes.func,
  handleCancelSearch: PropTypes.func,
  handleAdvanceTree: PropTypes.func,
  ids: PropTypes.arrayOf(PropTypes.string),
  classes: PropTypes.object,
};
